var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-add"},[_c('keep-alive',[_c('edit')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }